import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import {
  TABELA_ARMAZENAGEM_ENDPOINT,
} from '../../utils/api/domain/domain-endpoint-utils';

export async function fetchAll() {
  return doGetQCXRequest([
    TABELA_ARMAZENAGEM_ENDPOINT
  ]);
}

export async function fetchById(id) {
  return doGetQCXRequest([
    TABELA_ARMAZENAGEM_ENDPOINT,
    id,
  ]);
}

export async function register(data) {
  return doPostQCXRequest(
    [TABELA_ARMAZENAGEM_ENDPOINT],
    data
  );
}

export async function save(data) {
  return doPutQCXRequest(
    [TABELA_ARMAZENAGEM_ENDPOINT],
    data
  );
}

export async function activateById(id) {
  return doPutQCXActivateRequest(
    [TABELA_ARMAZENAGEM_ENDPOINT],
    id
  );
}

export async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [TABELA_ARMAZENAGEM_ENDPOINT],
    id
  );
}
